import script from "./ChangeUserEmailModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeUserEmailModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeUserEmailModal.vue?vue&type=style&index=0&id=c8267c18&scoped=true&lang=css"
script.__scopeId = "data-v-c8267c18"

export default script